import store from '@/store';

export default {
    install(Vue, options) {
        Vue.prototype.$can = function(permission) {
            return store.state.user.permissions.includes(permission);
        };

        Vue.prototype.$softLoginCan = function(permission) {
            return store.state.softLogin.permissions.includes(permission);
        };
    },
};
